import * as tslib_1 from "tslib";
import common from "@cloudpivot/common";
import { Component, Prop } from "vue-property-decorator";
import { DataSelectTextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/data-select-text-input-control";
import { Button, Modal, Tree, message } from "@h3/antd-vue";
import md5 from "md5";
import api from "./api";
let dataSelect = class dataSelect extends DataSelectTextInputControl {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.treeData = [];
        this.list = [];
        this.previewVisible = false;
        this.isLoading = false;
        this.checkedKeys = null;
        this.previewImage = "";
        this.type = "";
    }
    created() {
        this.type = this.control.options.fileType || "file";
        this.checkedKeys = this.getInitcheckedKeys();
    }
    getInitcheckedKeys() {
        if (this.type === 'file') {
            return [];
        }
        else {
            return {
                checked: [],
                halfChecked: []
            };
        }
    }
    showModal() {
        if (this.getFormControls) {
            const controls = this.getFormControls();
            const find = controls.find((item) => item.key === this.control.options.documentRoot.value);
            const { controller: { _value }, options: { name }, } = find;
            if (!_value) {
                this.$message.warning(`${name}不能为空`);
                return false;
            }
            let type = this.control.options.fileType || "file";
            this.type = type;
            let libraryCode = this.control.options.libraryCode || "yuanshi";
            console.log(this.control.options);
            this.visible = true;
            this.isLoading = true;
            this.checkedKeys = this.getInitcheckedKeys();
            api.getList(_value.id, type, libraryCode).then(({ data, errcode }) => {
                this.isLoading = false;
                if (errcode === 0) {
                    if (Array.isArray(data)) {
                        if (type === "file") {
                            this.translateData(data);
                        }
                        this.treeData = data;
                        this.initData(this.treeData);
                    }
                }
            });
        }
    }
    initData(data) {
        data.forEach(i => {
            i.scopedSlots = {
                title: 'tree',
            };
            if (i.children && i.children.length) {
                this.initData(i.children);
            }
        });
    }
    mounted() {
        // 预览/编辑
        if (this.readonly && this.val) {
            const list = JSON.parse(this.val);
            if (Array.isArray(list)) {
                this.list = list;
            }
            else {
                this.list = [];
            }
        }
    }
    translateData(data) {
        data.forEach((item) => {
            if (Array.isArray(item.children) && item.children.length) {
                item.disabled = this.searchFile(item.children);
                return this.translateData(item.children);
            }
            else {
                if (item.folder) {
                    item.disabled = true;
                }
            }
        });
    }
    searchFile(data) {
        let disabled = false;
        for (let i = 0, len = data.length; i < len; i++) {
            const item = data[i];
            if (Array.isArray(item.children) && item.children.length) {
                return this.searchFile(item.children);
            }
            else {
                if (item.folder) {
                    disabled = true;
                }
            }
        }
        return disabled;
    }
    handleCancel() {
        this.previewVisible = false;
        this.previewImage = "";
    }
    del(item, index) {
        const _this = this;
        this.$confirm({
            title: "提示",
            content: (h) => h("div", { style: "text-align:justify;" }, "是否确认删除？"),
            okText: "确定",
            cancelText: "取消",
            onOk() {
                _this.list.splice(index, 1);
                if (_this.list.length) {
                    _this.setValue(JSON.stringify(_this.list));
                }
                else {
                    _this.setValue("");
                }
            },
            onCancel() {
                // nothing to do
            },
        });
    }
    getUrl(data) {
        if (data.type === "folder") {
            const token = window.localStorage.getItem("token");
            const controls = this.getFormControls();
            const find = controls.find((item) => item.key === this.control.options.documentRoot.value);
            const { controller: { _value } } = find;
            let projectId = _value.id;
            let projectName = _value.neibubianma || _value.name;
            let origin = '';
            let currentHost = window.location.origin;
            if (location.host.indexOf('localhost') != -1 || location.host === "cloudpivot-dev.xgjktech.com.cn") {
                origin = location.protocol + '//cwork-web-dev.xgjktech.com.cn';
                currentHost = location.protocol + '//cloudpivot-dev.xgjktech.com.cn';
            }
            else {
                origin = location.protocol + "//sg-al-cwork-web.mediportal.com.cn";
            }
            let url = `${origin}/dingding-document-database/web/dist/#/knowledgeBase?fromWhere=yunshu&token=${token}&cloudpivotDomain=${currentHost}&fileId=${data.id}&projectName=${projectName}&projectId=${projectId}`;
            window.open(url, "_blank");
            return false;
        }
        this.handlePreview(data);
    }
    handlePreview(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (file.previewUrl) {
                file.previewUrl && window.open(file.previewUrl);
            }
            else {
                // 获取文件refId
                const refId = file.id;
                // @ts-ignore
                const formObj = JSON.parse(window.sessionStorage.getItem("formObj"));
                const token = window.localStorage.getItem("token");
                const ts = Date.now();
                const activityCode = formObj.activityCode || '';
                const schemaCode = formObj.bizSchema && formObj.bizSchema.code || '';
                const bizObjectId = formObj.bizObject && formObj.bizObject.id || '';
                const sheetCode = formObj.bizSheet && formObj.bizSheet.code || '';
                const instanceId = formObj.workflowInstanceId || '';
                const propertyCode = "";
                const source = 'kzdoc';
                const sign = md5(`preview:${refId}${source}${schemaCode}${activityCode}${instanceId}${bizObjectId}${ts}`);
                const type = file.name;
                if (type.indexOf(".png") === -1 &&
                    type.indexOf(".PNG") === -1 &&
                    type.indexOf(".jpg") === -1 &&
                    type.indexOf(".JPG") === -1) {
                    // 通过后缀识别类型
                    const isSupportCX = common.utils.isSupportCXFormat(file);
                    if (!isSupportCX) {
                        this.$message.info("该格式附件暂不支持预览");
                        return;
                    }
                    window.open(`${location.origin}/yunshu-file-system/web/dist/#/view?refId=${refId}&activityCode=${activityCode}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&propertyCode=${propertyCode}&ts=${ts}&sign=${sign}&token=${token}&source=${source}&instanceId=${instanceId}&bizObjectId=${bizObjectId}`);
                }
                else {
                    // 图片预览弹框
                    const params = {
                        refId: refId,
                        activityCode: activityCode,
                        schemaCode: schemaCode,
                        sheetCode: sheetCode,
                        propertyCode: propertyCode,
                        ts: ts,
                        instanceId: instanceId,
                        bizObjectId: bizObjectId,
                        sign: sign,
                        source: source
                    };
                    api.getUrl(file.id, params).then(({ data, errcode, errmsg }) => {
                        if (errcode === 0) {
                            this.previewImage = data.downloadUrl;
                            this.previewVisible = true;
                        }
                        else {
                            message.warning(errmsg || data);
                        }
                    });
                }
            }
        });
    }
    handleOk() {
        const { treeData, list, type } = this;
        const ids = [];
        list.forEach((item) => {
            ids.push(item.id);
        });
        let countLimit = this.control.options.countLimit || '';
        console.log('countLimit', countLimit, type);
        if (type === "file") {
            const checkedKeys = countLimit ? this.checkedKeys.checked : this.checkedKeys;
            if (!checkedKeys || checkedKeys.length === 0 || treeData.length === 0) {
                message.warning("请选择文件");
                return false;
            }
            // 已经选择的文件
            let folderList = [];
            checkedKeys.forEach((item) => {
                let arr = item.split("-");
                let o;
                arr.splice(0, 1);
                arr.forEach((item) => {
                    if (o && o["children"]) {
                        o = o["children"][item];
                    }
                    else if (treeData[item]) {
                        o = treeData[item];
                    }
                });
                if (o && !o.folder && !ids.includes(o.id)) {
                    list.push({
                        id: o.id,
                        name: o.name,
                        pos: item,
                        type: "file",
                    });
                }
                if (o && o.folder) {
                    folderList.push(o);
                }
            });
            if (folderList.length > 0 && folderList.length === checkedKeys.length) {
                message.warning("不支持选择文件夹");
            }
        }
        else {
            const checkedKeys = this.checkedKeys.checked;
            if (checkedKeys.length === 0 || treeData.length === 0) {
                message.warning("请选择文件");
                return false;
            }
            // 文件夹
            // console.log('checkedKeys', checkedKeys)
            // const o: any = this.getPos(checkedKeys);
            let keys = checkedKeys.map((item) => {
                const arr = item.split("-");
                arr.splice(0, 1);
                return arr.join("-");
            });
            const result = this.getNodeByFolder(keys);
            result.forEach((item) => {
                if (!ids.includes(item.id)) {
                    this.findNode(item.id)(this.treeData, (path) => {
                        list.push({
                            type: "folder",
                            id: item.id,
                            name: path.map((child) => child.title).join("/"),
                        });
                    });
                }
            });
        }
        if (countLimit) {
            let num = Number(countLimit);
            if (list.length > num) {
                message.warning(`最多只能选择${num}个文件`);
                list.splice(num, list.length - 1);
            }
        }
        this.visible = false;
        this.setValue(JSON.stringify(list));
    }
    getNode(arr) {
        const result = [];
        arr.forEach((item) => {
            let data = null;
            const keys = item.split("-");
            keys.forEach((key) => {
                if (data) {
                    data = data.children[+key];
                }
                else {
                    data = this.treeData[+key];
                }
            });
            if (!data.children) {
                result.push({
                    id: data.id,
                    name: data.title,
                });
            }
        });
        return result;
    }
    findNode(id) {
        const path = [];
        let level = 0;
        return function t(arr, fn) {
            for (let i = 0; i < arr.length; i++) {
                path.push(Object.assign({}, arr[i]));
                if (arr[i].id === id) {
                    fn && fn(path);
                    return arr[i];
                }
                else if (arr[i].children && arr[i].children.length) {
                    level++;
                    const find = t(arr[i].children, fn);
                    if (!find) {
                        path.splice(path.length - 1);
                        continue;
                    }
                    else {
                        return find;
                    }
                }
                path.splice(level, 1);
            }
            level--;
        };
    }
    // checkable  选择不联动
    getNodeByFolder(arr) {
        const result = [];
        arr.forEach((item) => {
            let data = null;
            const keys = item.split("-");
            keys.forEach((key) => {
                if (data) {
                    data = data.children[+key];
                }
                else {
                    data = this.treeData[+key];
                }
            });
            if (data) {
                result.push({
                    id: data.id,
                    name: data.title,
                });
            }
        });
        return result;
    }
    getPos(arr) {
        let a = arr.map((item) => {
            return item.split('-');
        });
        a.sort((a, b) => a.length - b.length);
        a = a.map((item) => item.join('-'));
        return this.controlData(a, []);
    }
    controlData(a, newArr) {
        const c = JSON.parse(JSON.stringify(a)).reverse();
        const f = c.find((item, index) => {
            if (c[index + 1]) {
                if (item.split('-').length > c[index + 1].split('-').length) {
                    return item;
                }
            }
        });
        if (f) {
            const left = f;
            const b = a.reduce((total, item) => {
                const reg = new RegExp(`^${item}`);
                if (!reg.test(left)) {
                    total.push(item);
                }
                return total;
            }, []);
            newArr.push(left);
            return this.controlData(b, newArr);
        }
        else {
            return ([...a, ...newArr]);
        }
    }
    downLoadList() {
        let refIds = this.list.map((item) => {
            return item.id;
        });
        api.getZipUrl(refIds.join(',')).then(({ data, errcode, errmsg }) => {
            console.log('data', data);
            if (errcode === 0) {
                let downloadUrl = data;
                const link = document.createElement('a');
                link.style.display = 'none';
                link.target = '_blank';
                link.href = downloadUrl.replace(/^http:/, 'https:');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            else {
                message.warning(errmsg || data);
            }
        });
    }
};
tslib_1.__decorate([
    Prop()
], dataSelect.prototype, "getFormControls", void 0);
dataSelect = tslib_1.__decorate([
    Component({
        name: "dataSelect",
        components: {
            AButton: Button,
            AModal: Modal,
            ATree: Tree,
        },
    })
], dataSelect);
export default dataSelect;
